// extracted by mini-css-extract-plugin
export var addButton = "_j2-0";
export var border = "_j2-8";
export var check = "_j2-h";
export var danger = "_j2-6";
export var dropdownContainer = "_j2-1";
export var editModalBody = "_j2-j";
export var footerContainer = "_j2-i";
export var fullWidth = "_j2-a";
export var hide = "_j2-9";
export var icon = "_j2-3";
export var input = "_j2-7";
export var inputFlex = "_j2-b";
export var inputWrapper = "_j2-c";
export var manualFocus = "_j2-5";
export var optionButton = "_j2-4";
export var pillWrapper = "_j2-e";
export var pointer = "_j2-2";
export var showOverflow = "_j2-f";
export var tagsFlex = "_j2-d";
export var xButton = "_j2-g";